import $ from 'jquery';

var DATA_TYPE;
var TOKEN_PROPERTY;

const cardServices = {
    init: function () {
        var self = this;
        self.working(true, 'Loading...');

        $(".cd-err-row").hide();

        $("#myToken").hide();

        window.addEventListener(
            'message', function (event) {
                var token;

                $("#myToken").text("");
                $("#myToken").hide();

                token = self.parse(event.data);

                if (token && token.validationError !== undefined) {
                    $("#tokenframe").focus();
                    $("#cc_error").show();
                    setTimeout(function () {
                        $("#cc_error").fadeOut();
                    }, 3400);
                    self.working(true, 'Issue...');
                    self.setFrame();
                    return false;
                }

                if (token){
                    $("#myToken").text(token[TOKEN_PROPERTY]);
                    localStorage.setItem('token', token[TOKEN_PROPERTY]);
                    console.log("TOKEN SET: ", token[TOKEN_PROPERTY])
                }
                // $("#myToken").fadeIn();
            }, false);

        self.setFrame();
        TOKEN_PROPERTY = self.scrubInput(self.getQueryVariable("tokenpropname", "message"), 30, "message", /^[0-9a-zA-Z]+$/);
    },
    ajax: function (data, url, success) {
        $.ajax({
            type: "POST",
            url: url,
            data: data,
            dataType: DATA_TYPE,
            timeout: function () {
                alert("Timeout");
            },
            success: function (data) {
                success(data);
            }
        })
    },
    getQueryVariable: function (variable, defaultValue) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] === variable) {
                return pair[1];
            }
        }
        return defaultValue ? defaultValue : (false);
    },
    isNumeric: function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },
    parse: function (data) {
        console.log("DATA ", data);
        try {
            return JSON.parse(data);
        } catch (err) {
            return null
        }
    },
    scrubInput: function (input, maxlen, fallback, pattern) {

        if (input && input.length !== 0 && input.length <= maxlen) {
            if (input.match(pattern)) {
                return input;
            }
        }
        return fallback;
    },
    setFrame: function () {
        var self = this;
        var style = '&css=input%3Afocus%7Boutline%3A%20none%3B%7Dbody%7Bmargin%3A0%21important%3B%7Dinput%7Bmargin%3A%200px%3B%20padding%3A%2012px%2010px%3B%20font-size%3A%2015px%3Bfont-family%3A%20arial%3B%20background-color%3A%20whitesmoke%3B%20border%3A%20none%3B%20width%3A%201000px%3B%7D';
        var opts = '?invalidinputevent=true';
        opts = opts + '&enhancedresponse=true';
        opts = opts + '&formatinput=true';
        opts = opts + style;

        var url = 'https://fts.cardconnect.com/itoke/ajax-tokenizer.html' + opts;
        if (process.env.NODE_ENV !== 'production') {
            url = 'https://fts-uat.cardconnect.com/itoke/ajax-tokenizer.html' + opts;
        }

        $("#tokenframe").attr("src", url);

        setTimeout(function () {
            self.working(false);
        }, 300);
    },
    submitButton: function () {

    },
    working: function (toggle, msg = '') {
        if (msg === '') {
            msg = 'working...';
        }
        if (toggle === true) {
            $("#_working")
                .text(msg)
                .show();
        } else {
            $("#_working").fadeOut();
        }
    }
}
DATA_TYPE = "json";

export default cardServices;
